import * as React from 'react';
import { declineNumeric, changeDotToComma } from '../../../shared/utils/format_helper';
import { StringLazyLoad, waitForImage } from '../../../shared/utils/lazy_load_helper';
import { shortenNumber } from '@cian/utils/lib/shared/shorten_number';
import { Link } from '../link/link';
import { ca } from '@cian/analytics';
import { ITrackingProductData } from '../../../shared/types/top_three';
import { ETransportType } from '../../types/newbuilding_recommendations';

const s = require('./popular_item.css');

interface IDeveloper {
  url: string;
  title: string;
}

export interface IJKPopularItemProps {
  metroInfo?: {
    timeType: string;
    name: string;
    lineColor: string;
    time: number;
  };
  id: number;
  title: string;
  url: string;
  isComplete: boolean;
  deadlineYear?: string;
  priceFrom?: number;
  priceTo?: number;
  address?: string;
  imageUrl: string;
  promoText: string;
  developers: IDeveloper[];
  trackingProductData: ITrackingProductData;
  position: number;
  onClick(): void;
}

const eventObject = {
  name: 'oldevent',
  category: 'main_newobjects',
  action: 'pop_ads',
  label: 'sale/JK',
  ecommerce: {
    click: {
      actionField: {
        list: 'main_newobjects',
      },
    },
  },
};

export class JKPopularItem extends React.Component<IJKPopularItemProps> {
  public renderAddress() {
    if (this.props.metroInfo) {
      return (
        <div className={s['c-popular-metro']}>
          <span className={s['c-popular-metro-name']}>
            <span
              className={s['c-line-marker']}
              style={{
                backgroundColor: `#${this.props.metroInfo.lineColor}`,
              }}
            />
            {this.props.metroInfo.name}
          </span>
          <span className={s['c-popular-metro-time']}>
            {this.props.metroInfo.time}
            &nbsp;
            {declineNumeric(this.props.metroInfo.time, ['минута', 'минуты', 'минут'])}
            &nbsp;
            {this.props.metroInfo.timeType === ETransportType.Walk ? 'пешком' : 'на транспорте'}
          </span>
        </div>
      );
    } else {
      return <div className={s['c-popular-address']}>{this.props.address}</div>;
    }
  }

  public formatCompleteYear(isComplete: boolean, deadlineYear?: string) {
    if (isComplete) {
      return 'ОБЪЕКТ СДАН';
    } else if (deadlineYear) {
      return `СДАЧА В  ${deadlineYear}`;
    } else {
      return 'ПРОЕКТ';
    }
  }

  public renderDevelopers() {
    const developers = this.props.developers;

    return (
      <div className={s['c-popular-developer']}>
        <span className={s['c-popular-developer-text']}>
          {`${developers.length > 1 ? 'Застройщики' : 'Застройщик'}
            ${developers.map(developer => `«${developer.title}»`).join(', ')}`}
        </span>
      </div>
    );
  }

  private dispatchCAEvent() {
    const brand = this.props.trackingProductData.brand ? this.props.trackingProductData.brand : '';
    const brandForEvent = brand ? brand.slice(0, brand.indexOf('/')) + '/developer_company' : 'none';

    Object.assign(eventObject.ecommerce.click, {
      products: [
        {
          name: this.props.title,
          id: this.props.id,
          brand: brandForEvent,
          category: 'sale/JK',
          position: this.props.position,
        },
      ],
    });

    ca('event', eventObject);

    this.props.onClick();
  }

  public render() {
    return (
      <Link
        href={this.props.url}
        className={`${s['c-popular-block']} ${s['c-popular-block-jk']} cg-col-8`}
        onClick={() => this.dispatchCAEvent()}
      >
        <StringLazyLoad
          onLoad={() => waitForImage(this.props.imageUrl)}
          renderEmpty={() => <div className={s['c-popular-photo-wrap']} />}
          renderLoading={() => <div className={s['c-popular-photo-wrap']} />}
          renderLoaded={(imageUrl: string) => (
            <div
              className={s['c-popular-photo-wrap']}
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            />
          )}
          renderError={() => <div className={s['c-popular-photo-wrap']} />}
        />
        {this.props.promoText && (
          <span className={s['c-popular-discount']}>
            <span className={s['c-popular-discount-content']}>{this.props.promoText}</span>
          </span>
        )}
        <div className={`${s['c-popular-info']} ${s['c-popular-info-jk']}`}>
          <span className={s['c-popular-top']}>
            <span className={s['c-popular-block-title']}>
              <span className={s['c-popular-block-title-text']}>{this.props.title}</span>
              <span className={s['c-popular-block-title-class']}>
                {this.formatCompleteYear(this.props.isComplete, this.props.deadlineYear)}
              </span>
            </span>
            {this.props.priceFrom && this.props.priceTo && (
              <span className={s['c-popular-price-range']}>
                от&nbsp;
                {changeDotToComma(shortenNumber(this.props.priceFrom))}
                &nbsp;до&nbsp;
                {changeDotToComma(shortenNumber(this.props.priceTo))}
                &nbsp;руб.
              </span>
            )}
          </span>
          {this.renderAddress()}
        </div>
        {this.props.developers.length > 0 && this.renderDevelopers()}
      </Link>
    );
  }
}
